export const validateMalo = (maloID: string) => {
  if (!maloID.match(/^[0-9]{11}$/)) {
    throw new Error('regex does not match');
  }

  // algorithm to validate maloID checksum
  // https://malo-generator.de

  let oddSum = 0;
  let evenSum = 0;
  for (let i = 1; i <= 10; i += 1) {
    if (i % 2 === 0) {
      evenSum += parseInt(maloID.charAt(i - 1), 10);
    } else {
      oddSum += parseInt(maloID.charAt(i - 1), 10);
    }
  }

  const sumTotal = evenSum * 2 + oddSum;

  const checksumRaw = 10 - (sumTotal % 10);
  const checksum = checksumRaw === 10 ? 0 : checksumRaw;

  if (maloID.charAt(10) !== checksum.toString()) {
    throw new Error('invalid checksum');
  }
};
